import * as z from "zod";

export const getWorkOrderInputProductNames = {
  name: "getWorkOrderInputProductNames" as const,
  input: z.object({}),
  output: z.object({ names: z.array(z.string()) }),
};
